import { Connect, ConnectItem } from '@ecdlink/graphql/lib';
import { api } from '../axios.helper';
import {
  BreastFeedingClubDto,
  CaregiverBaseDto,
  ClinicDto,
  Config,
  LeagueWithClinicRankingsDto,
} from '@ecdlink/core';
import { AddBreastFeedingClubInputModelInput } from '@ecdlink/graphql';

class CommunityService {
  _accessToken: string;

  constructor(accessToken: string) {
    this._accessToken = accessToken;
  }

  async getAllConnect(locale: string): Promise<Connect[]> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<{
      data: { GetAllConnect: Connect[] };
      errors?: {};
    }>(``, {
      id: 'GetAllConnect',
      variables: {
        locale,
      },
    });

    if (response.status !== 200) {
      throw new Error('Get All Connect Failed - Server connection error');
    }
    return response.data.data.GetAllConnect;
  }

  async getAllConnectItem(locale: string): Promise<ConnectItem[]> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<{
      data: { GetAllConnectItem: ConnectItem[] };
      errors?: {};
    }>(``, {
      id: 'GetAllConnectItem',
      variables: {
        locale,
      },
    });

    if (response.status !== 200) {
      throw new Error('Get All Connect Item Failed - Server connection error');
    }
    return response.data.data.GetAllConnectItem;
  }

  async getLeagueById(leagueId: string): Promise<LeagueWithClinicRankingsDto> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<{
      data: {
        leagueById: LeagueWithClinicRankingsDto;
      };
      errors?: {};
    }>(``, {
      id: 'getLeagueById',
      variables: {
        leagueId: leagueId,
      },
    });

    if (response.status !== 200 || !!response.data.errors) {
      throw new Error('getLeagueById Failed - Server connection error');
    }

    return response.data.data.leagueById;
  }

  async getClinicById(clinicId: string): Promise<ClinicDto> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<{
      data: {
        clinicById: ClinicDto;
      };
      errors?: {};
    }>(``, {
      id: 'getClinicById',
      variables: {
        clinicId: clinicId,
      },
    });

    if (response.status !== 200 || !!response.data.errors) {
      throw new Error('getClinicById Failed - Server connection error');
    }

    return response.data.data.clinicById;
  }

  async getAvailableCaregiversForBreastFeedingClub(
    clinicId: string
  ): Promise<CaregiverBaseDto[]> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<{
      data: {
        availableCaregiversForBreastFeedingClub: CaregiverBaseDto[];
      };
      errors?: {};
    }>(``, {
      id: 'getAvailableCaregiversForBreastFeedingClub',
      variables: {
        clinicId: clinicId,
      },
    });

    if (response.status !== 200 || !!response.data.errors) {
      throw new Error(
        'getAvailableCaregiversForBreastFeedingClub Failed - Server connection error'
      );
    }

    return response.data.data.availableCaregiversForBreastFeedingClub;
  }

  async getBreastFeedingClubs(
    clinicId: string
  ): Promise<BreastFeedingClubDto[]> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<{
      data: {
        breastFeedingClubs: BreastFeedingClubDto[];
      };
      errors?: {};
    }>(``, {
      id: 'getBreastFeedingClubs',
      variables: {
        clinicId: clinicId,
      },
    });

    if (response.status !== 200 || !!response.data.errors) {
      throw new Error('getBreastFeedingClubs Failed - Server connection error');
    }

    return response.data.data.breastFeedingClubs;
  }

  async addBreastFeedingClub(
    input: AddBreastFeedingClubInputModelInput
  ): Promise<BreastFeedingClubDto> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<{
      data: { addBreastFeedingClub: BreastFeedingClubDto };
      errors?: {};
    }>(``, {
      id: 'addBreastFeedingClub',
      variables: {
        input: input,
      },
    });

    if (response.status !== 200) {
      throw new Error('addBreastFeedingClub failed - Server connection error');
    }

    return response.data.data.addBreastFeedingClub;
  }
}

export default CommunityService;
